// extracted by mini-css-extract-plugin
export default {"container":"TagListItem_container__fKXNs","name":"TagListItem_name__QJRz7","all":"TagListItem_all__429M+","active":"TagListItem_active__FULaN"};